import { getQueryParam } from "@circle-react/helpers/urlHelpers";

interface UseOverrideFeatureFlagProps {
  isPaywallsCheckoutCustomizationPhase1Enabled: boolean;
}

const isBoolean = (input: string) => input === "true" || input === "false";

export const useOverrideFeatureFlag = ({
  isPaywallsCheckoutCustomizationPhase1Enabled,
}: UseOverrideFeatureFlagProps): UseOverrideFeatureFlagProps => {
  const checkoutV2QueryParam = getQueryParam("v2") || "";
  const shouldEnableCheckoutV2 = isBoolean(checkoutV2QueryParam)
    ? checkoutV2QueryParam === "true"
    : null;

  return {
    isPaywallsCheckoutCustomizationPhase1Enabled:
      shouldEnableCheckoutV2 ?? isPaywallsCheckoutCustomizationPhase1Enabled,
  };
};
